import React from 'react';
import { X } from 'lucide-react';
import { GlassCard } from './GlassCard';
interface FeatureModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: {
    description: string;
    features: string[];
    benefits: string[];
  };
  isDark?: boolean;
}
export function FeatureModal({
  isOpen,
  onClose,
  title,
  content,
  isDark = false
}: FeatureModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} data-id="element-112">
      <GlassCard className="max-w-2xl w-full max-h-[90vh] overflow-y-auto animate-in zoom-in-95 duration-200" onClick={(e: React.MouseEvent) => e.stopPropagation()} data-id="element-113">
        <div className="flex justify-between items-start mb-6" data-id="element-114">
          <h2 className="text-3xl font-bold" data-id="element-115">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors text-gray-500 dark:text-gray-400" data-id="element-116">
            <X className="w-5 h-5" data-id="element-117" />
          </button>
        </div>

        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed" data-id="element-118">
          {content.description}
        </p>

        <div className="mb-8" data-id="element-119">
          <h3 className="text-xl font-bold mb-4" data-id="element-120">Key Features</h3>
          <div className="space-y-3" data-id="element-121">
            {content.features.map((feature, index) => <div key={index} className="flex items-start gap-3" data-id="element-122">
                <div className="w-6 h-6 rounded-full bg-brand-100 dark:bg-brand-900/50 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-123">
                  <div className="w-2 h-2 rounded-full bg-brand-600 dark:bg-brand-400" data-id="element-124" />
                </div>
                <p className="text-gray-700 dark:text-gray-300" data-id="element-125">{feature}</p>
              </div>)}
          </div>
        </div>

        <div data-id="element-126">
          <h3 className="text-xl font-bold mb-4" data-id="element-127">Business Benefits</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-128">
            {content.benefits.map((benefit, index) => <div key={index} className="p-4 bg-brand-50 dark:bg-brand-900/30 rounded-xl border border-brand-100 dark:border-brand-800" data-id="element-129">
                <p className="text-sm font-medium text-gray-800 dark:text-gray-200" data-id="element-130">
                  {benefit}
                </p>
              </div>)}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700" data-id="element-131">
          <button onClick={onClose} className="w-full px-6 py-3 bg-brand-500 text-white rounded-xl font-medium hover:bg-brand-600 transition-colors" data-id="element-132">
            Got it, thanks!
          </button>
        </div>
      </GlassCard>
    </div>;
}